import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const Home = () => {
  return (
    <>
      <SEO 
        title="Home | My App" 
        description="Welcome to My App - your solution for..." 
      />
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-center mb-8">Welcome to My App</h1>
        <div className="max-w-3xl mx-auto">
          <p className="text-lg text-gray-700 mb-6">
            This is a scalable React application with routing, authentication, and SEO optimization.
          </p>
          <div className="flex justify-center">
            <Link to="/login" className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 mr-4">
              Login
            </Link>
            <Link to="/dashboard" className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">
              Go to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
